<template>
  <v-img :aspect-ratio="16/9" :src="profileImage" :class="backcolor">

    <div class="sw--pa-initials" v-if="image === ''">
      <v-avatar
        :size="96" 
        v-text="initials"
        class="font-weight-regular white--text display-1"
      />
    </div>

    <div class="sw--pa-actions" v-if="canEdit">
      <v-btn fab dark small color="green" @click="openAvatarImages" v-if="canUpload">
        <v-icon dark>cloud_upload</v-icon>
      </v-btn>
      <v-btn fab dark small color="red" class="ml-0" @click="removeAvatar" v-if="canRemove">
        <v-icon dark>delete</v-icon>
      </v-btn> 
    </div>

    <div v-if="canUpload"> 
      <input type="file" id="avatar-file" style="display:none;" accept="image/jpeg,image/png" @change="uploadAvatar"/>
    </div>
  </v-img>
</template>

<style>
  .sw--pa-initials {
    position: relative; 
    left: calc(50% - 48px);
    top: calc(50% - 48px);
    user-select: none;
  }
  .sw--pa-actions {
    position: absolute; 
    right: 0px;
    bottom: 0px;
  }
</style>

<script>
  import baseUtils from '@utils/base'

  export default {
    name: 'profile-avatar',
    props: {
      title: String,
      avatar: String,
      canUpload: Boolean,
      canRemove: Boolean,
      chatId: {
        type: Number,
        default: 0
      },
      changed: Function
    },
    data: () => ({
      image: ''
    }),
    computed: {
      canEdit() {
        return this.canUpload === true || this.canRemove === true
      },
      initials() {
        return (this.title != null ) ? baseUtils.getAvatarLetters(this.title).toUpperCase() : ''
      },
      backcolor() {
        if (this.image !== '')
          return ''
        // TODO: make one common function
        const hash = baseUtils.hashCode(this.title)
        const colors = [
          'bc-F36C60',
          'bc-F06292',
          'bc-BA68C8',
          'bc-9575CD',
          'bc-7986CB',
          'bc-91A7FF',
          'bc-4FC3F7',
          //'bc-4DD0E1',
          //'bc-4DB6AC',
          //'bc-42BD41',
          'bc-AED581',
          'bc-DCE775',
          'bc-FFF176',
          'bc-FFB74D',
          'bc-FF8A65',
          'bc-FF8A65',
          'bc-90A4AE',
        ]
        return colors[hash % colors.length]
      },
      profileImage() {
        return this.image != '' ? 'data:image/*;base64,' + this.image : ''
      }
    },
    methods: {
      openAvatarImages() {
        document.getElementById('avatar-file').click()
      },
      uploadAvatar(ev) {
        let file = ev.target.files[0]
        let extension = file.name.split('.').pop()
        const reader = new FileReader()
        reader.onload = (e) => { 
          let data = btoa(e.target.result)
          this.upload(data, extension)
        }
        reader.readAsBinaryString(file)
      },
      upload(data, extension) {
        console.log('--', extension)
        ///this.image = /*'data:image/' + extension + ';base64,' +*/ data
        if (this.chatId != 0) {
          this.$store.dispatch('uploadChatAvatar', {chatId: this.chatId, avatar: data}).then(() => {
            this.image = data
            if (this.changed !== undefined)
              this.changed(data, this.chatId)
          })
        } else {
          this.$store.dispatch('uploadUserAvatar', data).then(() => {
            this.image = data
            if (this.changed !== undefined)
              this.changed(this.image, -1)
          })
        }
      },
      removeAvatar() {
        this.$store.dispatch('updateUserProfile', { key: 'avatar', value: '' }).then(() => {
          this.image = ''
          if (this.changed !== undefined)
            this.changed('', -1)
        })
      },
    },
    watch: {
      avatar: function(newValue, oldValue) {
        if (newValue != oldValue) {
          this.image = newValue
        }
      }
    }
  }
</script>
